<template>
  <v-app>
    <router-view></router-view>
    <loading></loading>
  </v-app>
</template>

<script>
import loading from '@/components/elements/loading'

export default {
  name: 'app',
  components: {
    loading
  },
  mounted: function() {}
}
</script>

<style lang="scss">
// @import 'static/css/font.css';
// @import 'static/css/font-awesome.min.css';
// @import 'static/css/all.css';
@import url('https://unpkg.com/vue-multiselect@2.1.0/dist/vue-multiselect.min.css');

@import url('https://fonts.googleapis.com/css?family=Kanit:300,400,600|Roboto:100,300,400,500,700,900|Sarabun:300,400,600,700,800|Material+Icons|Nunito:300,400,600,700&display=swap');
@import './assets/css/app.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue